document.addEventListener('DOMContentLoaded', () => {

  async function updateCartCount() {
    try {
      const cart = await fetch('/cart.js').then(r => r.json());
      const el = document.querySelector('.cart-count');
      if (el) el.textContent = cart.item_count;
    } catch (e) {}
  }
  updateCartCount();

  document.querySelectorAll('.btn-add-cart').forEach(btn => {
    btn.dataset.originalText = btn.textContent.trim();
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      const form = this.closest('form');
      if (!form) return;
      const variantId = form.querySelector('input[name="id"]')?.value;
      if (!variantId) return;
      btn.disabled = true;
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (response.ok) {
          await updateCartCount();
          btn.textContent = '✓';
          setTimeout(() => {
            btn.textContent = btn.dataset.originalText;
            btn.disabled = false;
          }, 2000);
        } else {
          btn.disabled = false;
        }
      } catch (e) {
        btn.disabled = false;
      }
    });
  });

  document.querySelectorAll('[data-tool]').forEach(btn => {
    btn.addEventListener('click', () => {
      const toolId = btn.dataset.tool;
      document.querySelectorAll('.tool-frame').forEach(f => f.classList.remove('active'));
      const frame = document.getElementById('tool-' + toolId);
      if (frame) {
        frame.classList.add('active');
        const iframe = frame.querySelector('iframe[data-src]');
        if (iframe && !iframe.src) iframe.src = iframe.dataset.src;
      }
    });
  });

  document.querySelectorAll('.tool-close').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.tool-frame').classList.remove('active');
    });
  });

  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const mobileNav = document.getElementById('mobile-nav');
  if (mobileMenuBtn && mobileNav) {
    mobileMenuBtn.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
    });
  }

});